'use client'

import React from 'react'

const UserSummary = ({ desc }) => {
    return (
        <div className="flex flex-col gap-5 py-5 xs:py-5 ">
            <h2 className="text-gray-900 text-[20px] leading-[22px] font-bold">Summary</h2>
            <div className="text-secondary text-[16px] leading-[26px] font-liberation font-medium" dangerouslySetInnerHTML={{ __html: desc }} >
            </div>
        </div>
    )
}

export default UserSummary